



























































import { defineComponent, onMounted, PropType, ref } from "@vue/composition-api";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import { $t } from "@/lib/i18nHelpers";
import BaseIconButton from "@/components/BaseIconButton";
import BaseSpinner from "@/components/BaseSpinner";
import RichTextarea from "@/components/RichTextarea";

export default defineComponent({
  name: "BaseSendMessage",
  components: { RichTextarea, BaseIconButton, BaseSpinner },
  props: {
    keepFocus: { type: Boolean, default: false },
    sending: { type: Boolean, required: true },
    disabled: { type: Boolean, default: false },
    transparent: { type: Boolean, default: false },
    placeholder: { type: String as PropType<TranslateResult | string>, default: $t("Message") },
    priceAmount: { type: String },
    appendIcon: { type: String },
    externalAppendIcon: { type: String, default: "msr-send" },
    prependIcon: { type: String },
    prependIconColor: { type: String },
    externalPrependIcon: { type: String },
    allowSend: {
      type: Function as PropType<(v: string) => boolean>,
      default: (value: string) => value.trim().length > 0,
    },
    allowEmoji: { type: Boolean, default: true },
    disableTransition: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const baseInput = ref<Vue | undefined>();
    const value = ref("");
    const focused = ref(false);
    const inputFocus = ref<() => void>(() => {});

    const onFocus = () => {
      focused.value = true;
      emit("focus");
    };

    const clearInput = () => {
      value.value = "";
      emit("input", value.value);
    };

    const inputMessage = (v: string) => {
      value.value = v;
      emit("input", value.value);
    };

    const sendMessage = useAuthorisedOnly(() => {
      if (!props.allowSend(value.value)) {
        return;
      }
      emit("send", value.value.trim(), clearInput);
      if (props.keepFocus) {
        inputFocus.value();
      }
    });

    onMounted(() => {
      emit("manualInput", inputMessage);
    });

    return {
      focused,
      value,
      baseInput,
      inputFocus,
      sendMessage,
      inputMessage,
      onFocus,
    };
  },
});
